import { SearchableOrganizationRecord } from 'lib/types/searchable';
import { AdjudicationAreaWithId } from 'lib/types/adjudicationArea';
import { State } from 'lib/enums';
import { PublisherFilters } from '../helpers/publisherSearch';

type SearchResultsSummaryDescriptionProps = {
  searchText: string;
  publisherResults: SearchableOrganizationRecord[];
  activeFilters: PublisherFilters;
};

export function SearchResultsSummaryDescription({
  searchText,
  publisherResults,
  activeFilters
}: SearchResultsSummaryDescriptionProps) {
  const searchDescription = searchText ? `for "${searchText}"` : '';
  const filterDescription = generateFilterDescription(activeFilters);

  const description = [searchDescription, filterDescription]
    .filter(Boolean)
    .join(' ');

  const hasResults = publisherResults.length > 0;
  const prefix = hasResults ? 'Showing publishers' : 'No publishers found';

  return (
    <p className="text-sm text-column-gray-700 font-semibold">
      {prefix} {description}
    </p>
  );
}

function generateFilterDescription(activeFilters: PublisherFilters) {
  const locationDescription = generateLocationFilterDescription(
    activeFilters.locationFilter.stateFilter
  );

  const adjudicationDescription = generateAdjudicationFilterDescription(
    activeFilters.adjudicationFilter?.countyFilter,
    activeFilters.adjudicationFilter?.stateFilter
  );

  const descriptionParts = [locationDescription, adjudicationDescription]
    .filter(Boolean)
    .join(' and ');

  return descriptionParts;
}

function generateLocationFilterDescription(
  stateId: number | undefined
): string {
  if (!stateId) {
    return '';
  }

  return `located in ${State.by_value(stateId)?.label}`;
}

function generateAdjudicationFilterDescription(
  county: AdjudicationAreaWithId | undefined,
  state: AdjudicationAreaWithId | undefined
): string {
  if (county) {
    return `adjudicated in ${county.name}`;
  }

  if (state) {
    return `adjudicated in ${state.name}`;
  }

  return '';
}
